// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__26ZpD","insightsList":"newBusinessInsightsMenu_insightsList__2Aeqg","active":"newBusinessInsightsMenu_active__3sPwe"};